/* =========================================================================
   KIKA — Atrinktos naujienos (featured stories) · behaviour
   Config lives in <script type="application/json" id="kfs-data">:
     config.demo = true  → story documents come from window.KFS_DEMO_DOCS (prototype)
     config.demo = false → story documents are fetched from story.url
                           (Shopify article with ?view=embed)
   Each story document is rendered in an <iframe srcdoc>. That keeps the
   Lovable CSS/JS isolated from the theme, and it works on Shopify, which
   refuses to frame its own storefront URLs (frame-ancestors 'none').
   ========================================================================= */
(function () {
  'use strict';

  var root = document.getElementById('kfs-root');
  var layer = document.getElementById('kfs-layer');
  var dataEl = document.getElementById('kfs-data');
  if (!root || !layer || !dataEl || root.getAttribute('data-kfs-ready')) return;
  root.setAttribute('data-kfs-ready', '1');

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var stories = (data && data.stories) || [];
  var cfg = (data && data.config) || {};
  if (!stories.length) return;

  var DEMO = !!cfg.demo;
  var HASH = cfg.hashPrefix || 'apzvalga-';
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

  // position:fixed must not be trapped by a transformed theme wrapper
  if (layer.parentNode !== document.body) document.body.appendChild(layer);

  /* ------------------------------------------------------------ helpers */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function extend(a, b) { if (b) for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k]; return a; }
  function params(i, extra) {
    var s = stories[i] || {};
    return extend({ kfs_id: s.id, kfs_position: i + 1, kfs_title: s.title }, extra);
  }
  function emit(name, payload) {
    var ev = extend({ event: name }, payload);
    (window.dataLayer = window.dataLayer || []).push(ev);
    if (typeof window.clarity === 'function') { try { window.clarity('event', name); } catch (e) {} }
    if (name === 'kfs_open' || name === 'kfs_add_to_cart') clarityTags(name, ev.kfs_id);
    // IO-6328: Customer events pixel "KIKA story tracking" sends these to GA4
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) {}
    if (DEMO && window.console) console.info('[kfs]', ev);
  }
  // IO-6328: products featured in stories opened in the last 7 days (localStorage kfs:attribution,
  // one entry per product handle). On checkout_completed the "KIKA story tracking" pixel sends
  // kfs_purchase for each bought product found here.
  var ATTRIBUTION_DAYS = 7;
  function rememberStory(id, handles) {
    if (!id || !handles.length) return;
    var now = Date.now();
    var list; try { list = JSON.parse(localStorage.getItem('kfs:attribution') || '[]') || []; } catch (e) { list = []; }
    list = list.filter(function (x) { return x && handles.indexOf(x.product) < 0 && now - x.ts < ATTRIBUTION_DAYS * 864e5; });
    handles.forEach(function (h) { list.push({ story: id, product: h, ts: now }); });
    try { localStorage.setItem('kfs:attribution', JSON.stringify(list.slice(-50))); } catch (e) {}
  }
  // IO-6328: Clarity events carry no parameters, so the stories opened / added to cart are also set
  // as Clarity tags. They are kept in sessionStorage (kfs:session) and layout/theme.liquid sets them
  // again on every later page, so Clarity can filter what visitors did after a story.
  function clarityTags(name, id) {
    if (typeof window.clarity !== 'function' || !id) return;
    var t; try { t = JSON.parse(sessionStorage.getItem('kfs:session') || '{}') || {}; } catch (e) { t = {}; }
    var key = name === 'kfs_open' ? 'opened' : 'added';
    t[key] = t[key] || [];
    if (t[key].indexOf(id) < 0) t[key].push(id);
    try { sessionStorage.setItem('kfs:session', JSON.stringify(t)); } catch (e) {}
    try {
      if (t.opened) { window.clarity('set', 'kfs_opened', 'yes'); window.clarity('set', 'kfs_story', t.opened); }
      if (t.added) window.clarity('set', 'kfs_story_add_to_cart', t.added);
      if (name === 'kfs_open') window.clarity('upgrade', 'kfs_open');
    } catch (e) {}
  }
  function productHandle(url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  function indexOfId(id) { for (var i = 0; i < stories.length; i++) if (stories[i].id === id) return i; return -1; }
  function idFromHash() {
    var h = ''; try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { h = location.hash.slice(1); }
    return h.indexOf(HASH) === 0 ? h.slice(HASH.length) : null;
  }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  var ICON_OK = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#5FCE36"/><path d="M5.8 10.3l2.6 2.6 5.8-5.8" fill="none" stroke="#183306" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_ERR = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#EE5757"/><path d="M10 5.6v5.2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/><circle cx="10" cy="14.3" r="1.2" fill="#FFFFFF"/></svg>';
  var NEXT_CSS = '#kfs-next{font-family:"General Sans","Helvetica Neue",Arial,sans-serif;padding:8px 20px 40px;background:#FFFFFF;}' +
    '#kfs-next .kfs-next-in{max-width:1080px;margin:0 auto;display:flex;flex-wrap:wrap;align-items:center;gap:6px 16px;padding:20px 24px;border-radius:16px;background:#F2F1E7;color:#183306;}' +
    '#kfs-next .kfs-next-k{flex-basis:100%;font-size:13px;line-height:18px;font-weight:500;color:#697064;}' +
    '#kfs-next .kfs-next-t{flex:1 1 200px;min-width:0;font-size:18px;line-height:24px;font-weight:600;}' +
    '#kfs-next .kfs-next-b{border:0;border-radius:128px;background:#183306;color:#FFFFFF;font:600 16px/20px "General Sans","Helvetica Neue",Arial,sans-serif;padding:12px 22px;cursor:pointer;}' +
    '@media (hover:hover){#kfs-next .kfs-next-b:hover{background:#5FCE36;}}' +
    '#kfs-next .kfs-next-b:focus-visible{outline:2px solid #183306;outline-offset:2px;}';

  /* ------------------------------------------------------------ seen state */
  var SEEN_KEY = 'kfs:seen';
  var items = $$('.kfs-item', root);
  function readSeen() { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]') || []; } catch (e) { return []; } }
  function paintSeen() {
    var seen = readSeen();
    items.forEach(function (li) {
      var on = seen.indexOf(li.getAttribute('data-id')) !== -1;
      li.classList.toggle('is-seen', on);
      var lbl = $('.kfs-seen-label', li);
      if (lbl) lbl.hidden = !on;
    });
  }
  function markSeen(id) {
    var seen = readSeen();
    if (seen.indexOf(id) === -1) {
      seen.push(id);
      try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen.slice(-60))); } catch (e) {}
    }
    paintSeen();
  }
  paintSeen();

  /* ------------------------------------------------------------ the row */
  var track = $('.kfs-track', root);
  var rowPrev = $('[data-kfs-row="prev"]', root);
  var rowNext = $('[data-kfs-row="next"]', root);
  function syncRow() {
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    root.setAttribute('data-overflow', max > 2 ? 'true' : 'false');
    if (rowPrev) rowPrev.disabled = track.scrollLeft <= 2;
    if (rowNext) rowNext.disabled = track.scrollLeft >= max - 2;
  }
  function scrollRow(dir) {
    var dx = dir * Math.max(200, track.clientWidth * 0.8);
    try { track.scrollBy({ left: dx, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft += dx; }
  }
  if (rowPrev) rowPrev.addEventListener('click', function () { scrollRow(-1); });
  if (rowNext) rowNext.addEventListener('click', function () { scrollRow(1); });
  if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(syncRow); }, { passive: true });
  window.addEventListener('resize', syncRow);
  document.addEventListener('kfs:resync', syncRow);
  syncRow();

  // the one deliberate motion: unseen rings draw in when the row first shows up
  if ('IntersectionObserver' in window) {
    if (!reduceMotion) { root.classList.add('is-armed'); void root.offsetWidth; }
    var rowIO = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      rowIO.disconnect();
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { root.classList.add('is-revealed'); }); });
      emit('kfs_impression', { kfs_count: stories.length });
    }, { threshold: 0.35 });
    rowIO.observe(root);
  }

  // bubble hero videos: muted loops that play only while the row is on screen; reduced motion
  // or Save-Data keeps the poster and never downloads the video (preload="none")
  var bubbleVideos = $$('.kfs-video', root);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  if (bubbleVideos.length && !reduceMotion && !saveData) {
    var playBubbles = function (on) {
      bubbleVideos.forEach(function (v) {
        if (on) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        playBubbles(entries[0].isIntersecting);
      }).observe(root);
    } else {
      playBubbles(true);
    }
  }

  /* ------------------------------------------------------------ documents */
  var docCache = {};
  function getDoc(s) {
    if (DEMO) {
      var docs = window.KFS_DEMO_DOCS || {};
      return docs[s.id] ? Promise.resolve(docs[s.id]) : Promise.reject(new Error('demo document missing'));
    }
    if (!s.url) return Promise.reject(new Error('story url missing'));
    if (!docCache[s.url]) {
      docCache[s.url] = fetch(s.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .catch(function (err) { delete docCache[s.url]; throw err; });
    }
    return docCache[s.url];
  }
  function between(html, name) {
    var a = '<!--kfs:' + name + '-->', b = '<!--/kfs:' + name + '-->';
    var i = html.indexOf(a), j = html.indexOf(b, i + a.length);
    return i < 0 || j < 0 ? null : html.slice(i + a.length, j);
  }
  function prepareDoc(html) {
    // Shopify injects app embeds (Kaching, Judge.me, wishlist…) even into layout-none
    // templates; keep only the parts article.embed.liquid marked, so they don't run in the reader.
    var headPart = between(html, 'head'), bodyPart = between(html, 'body');
    if (headPart !== null && bodyPart !== null) {
      html = '<!doctype html><html lang="lt"><head>' + headPart + '</head><body>' + bodyPart + '</body></html>';
    }
    // links leave the iframe; the drawer has its own buy bar, so the content's one is hidden
    var inject = '<base target="_top"><style id="kfs-embed-style">#kSticky,.k-sticky{display:none!important}</style>';
    if (/<head[^>]*>/i.test(html)) return html.replace(/<head[^>]*>/i, function (m) { return m + inject; });
    return '<!doctype html><html lang="lt"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">' +
      inject + '</head><body>' + html + '</body></html>';
  }

  /* ------------------------------------------------------------ the reader layer */
  var panel = $('.kfs-panel', layer);
  var overlay = $('.kfs-overlay', layer);
  var head = $('.kfs-phead', layer);
  var progress = $('.kfs-progress', layer);
  var thumb = $('.kfs-pthumb', layer);
  var thumbImg = $('.kfs-pthumb img', layer);
  var titleEl = $('.kfs-ptitle', layer);
  var countEl = $('.kfs-count', layer);
  var prevBtn = $('[data-kfs-prev]', layer);
  var nextBtn = $('[data-kfs-next]', layer);
  var pbody = $('.kfs-pbody', layer);
  var frame = $('.kfs-frame', layer);
  var pageLink = $('[data-kfs-page]', layer);
  var announce = $('[data-kfs-announce]', layer);
  var foot = $('.kfs-pfoot', layer);
  var priceBox = $('.kfs-price', layer);
  var pNow = $('.kfs-pnow', layer);
  var pWas = $('.kfs-pwas', layer);
  var pLoy = $('.kfs-ploy', layer);
  var pLoyV = $('.kfs-ploy-v', layer);
  var statusEl = $('.kfs-status', layer);
  var pdpBtn = $('[data-kfs-pdp]', layer);
  var pdpLink = $('.kfs-pdp-link', layer);
  var buyBtn = $('[data-kfs-buy]', layer);

  var current = -1, isOpen = false, opener = null, openedAt = 0, historyMode = null;
  var loadToken = 0, loadTimer = null, loadedId = null, closeTimer = null;
  var cartState = {};

  var segs = stories.map(function (s, i) {
    var li = document.createElement('li');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kfs-seg';
    b.setAttribute('aria-label', (i + 1) + ' iš ' + stories.length + ': ' + s.title);
    b.addEventListener('click', function () { go(i, 'progress'); });
    li.appendChild(b);
    progress.appendChild(li);
    return b;
  });

  function load(i, force) {
    var s = stories[i];
    if (!force && loadedId === s.id && pbody.classList.contains('is-loaded')) return;
    var token = ++loadToken;
    loadedId = null;
    pbody.classList.remove('is-loaded', 'is-error');
    clearTimeout(loadTimer);
    loadTimer = setTimeout(function () { if (token === loadToken) fail(i); }, 15000);
    frame.setAttribute('title', 'Apžvalga: ' + s.title);
    getDoc(s).then(function (html) {
      if (token !== loadToken) return;
      frame.onload = function () {
        if (token !== loadToken) return;
        clearTimeout(loadTimer);
        loadedId = s.id;
        pbody.classList.add('is-loaded');
        enhance(i);
      };
      frame.srcdoc = prepareDoc(html);
    }).catch(function () { if (token === loadToken) fail(i); });
  }
  function fail(i) {
    clearTimeout(loadTimer);
    pbody.classList.add('is-error');
    emit('kfs_error', params(i));
  }

  function hasOpenDialog(doc) {
    return $$('[role="dialog"]', doc).some(function (d) {
      var cs = doc.defaultView.getComputedStyle(d);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    });
  }

  // Same-origin hooks into the story document
  function enhance(i) {
    var s = stories[i], doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc || !doc.body) return;

    var nextStory = stories[i + 1];
    if (nextStory && !doc.getElementById('kfs-next')) {
      var wrap = doc.createElement('div');
      wrap.id = 'kfs-next';
      wrap.innerHTML = '<style>' + NEXT_CSS + '</style><div class="kfs-next-in">' +
        '<span class="kfs-next-k">Kita atrinkta naujiena</span><span class="kfs-next-t"></span>' +
        '<button type="button" class="kfs-next-b">Skaityti</button></div>';
      wrap.querySelector('.kfs-next-t').textContent = nextStory.title;
      wrap.querySelector('.kfs-next-b').addEventListener('click', function () { go(i + 1, 'end_card'); });
      doc.body.appendChild(wrap);
    }

    var handles = s.product && productHandle(s.product.url) ? [productHandle(s.product.url)] : [];
    $$('a[href]', doc).forEach(function (a) {
      var h = productHandle(a.href);
      if (h && handles.indexOf(h) < 0) handles.push(h);
    });
    rememberStory(s.id, handles);

    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto|tel):/i.test(href)) return;
      e.preventDefault();
      if (s.product && productHandle(a.href) && productHandle(a.href) === productHandle(s.product.url)) {
        emit('kfs_content_cta', params(i, { kfs_cta: a.getAttribute('data-cta') || 'link' }));
        buy('content');
        return;
      }
      if (productHandle(a.href)) emit('kfs_content_product', params(i, { kfs_product: productHandle(a.href) }));
      navigate(a.href);
    });

    // Esc inside the story closes the reader, unless the story has its own dialog open
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || hasOpenDialog(doc)) return;
      close();
    }, true);
  }

  /* ------------------------------------------------------------ buy bar */
  function buyMode(p) {
    if (!p) return 'none';
    if (p.available === false) return 'soldout';
    if (p.singleVariant === false || (!DEMO && !p.variantId)) return 'choose';
    return 'add';
  }
  function setLabel(text) {
    buyBtn.textContent = '';
    var sp = document.createElement('span');
    sp.textContent = text;
    buyBtn.appendChild(sp);
  }
  function setBuy(state) {
    var p = stories[current].product, mode = buyMode(p);
    buyBtn.classList.remove('is-done');
    buyBtn.disabled = false;
    buyBtn.removeAttribute('aria-busy');
    pdpBtn.hidden = false;
    pdpLink.hidden = false;
    if (mode === 'soldout') { setLabel('Išparduota'); buyBtn.disabled = true; return; }
    if (mode === 'choose') { setLabel('Pasirinkti variantą'); pdpBtn.hidden = true; pdpLink.hidden = true; return; }
    if (state === 'loading') {
      buyBtn.setAttribute('aria-busy', 'true');
      buyBtn.innerHTML = '<span class="kfs-spin" aria-hidden="true"></span><span>Dedama…</span>';
      return;
    }
    if (state === 'added') { buyBtn.classList.add('is-done'); setLabel('Peržiūrėti krepšelį'); return; }
    setLabel('Į krepšelį');
  }
  function setStatus(type, text) {
    if (!type) { priceBox.classList.remove('has-status'); statusEl.textContent = ''; return; }
    statusEl.innerHTML = type === 'ok' ? ICON_OK : ICON_ERR;
    var t = document.createElement('span');
    t.textContent = text;
    statusEl.appendChild(t);
    priceBox.classList.add('has-status');
  }
  function renderFoot(i) {
    var s = stories[i], p = s.product;
    if (!p) { foot.hidden = true; return; }
    foot.hidden = false;
    pNow.textContent = p.price || '';
    pWas.textContent = p.compareAt || '';
    pWas.hidden = !p.compareAt;
    pLoy.hidden = !p.loyalty;
    pLoyV.textContent = p.loyalty || '';
    pdpBtn.href = p.url;
    pdpLink.href = p.url;
    if (DEMO) { pdpBtn.target = '_blank'; pdpLink.target = '_blank'; }
    if (cartState[s.id] === 'added') { setBuy('added'); setStatus('ok', 'Pridėta į krepšelį'); }
    else { setBuy('idle'); setStatus(''); }
  }
  function addToCart(p) {
    if (DEMO) return new Promise(function (resolve) { setTimeout(resolve, 700); });
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function refreshCart() {
    // kika.lt's cart is the Kaching side cart; its header count only exists for a non-empty cart,
    // so ask Kaching to re-render (same call as product-form.js) instead of editing count text.
    // Kaching also wraps window.fetch, so it re-renders on its own if the API is not there yet.
    if (!DEMO && window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
      try { window.kachingCartApi.refreshCart(); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('kfs:cart-updated'));
  }
  function stepAsideForCart() {
    // Kaching opens its side cart after a /cart/add.js (body gets kaching-body__cart-open) and it
    // renders below the reader, so the user would be left with an invisible open cart that appears
    // when the reader closes. The theme has no verified way to close the Kaching drawer, so the
    // reader steps aside instead, the same as the "Peržiūrėti krepšelį" button does (openCart()).
    // Both the buy bar and the in-content CTA reach this through buy(). If Kaching does not open
    // within 2.5s the reader stays.
    if (DEMO || !window.MutationObserver) return;
    var body = document.body, cls = 'kaching-body__cart-open', obs = null, timer = null;
    function stop() { if (obs) obs.disconnect(); obs = null; clearTimeout(timer); }
    function check() {
      if (!body.classList.contains(cls)) return false;
      stop();
      if (isOpen) close(false, true);
      return true;
    }
    if (check()) return;
    obs = new MutationObserver(check);
    obs.observe(body, { attributes: true, attributeFilter: ['class'] });
    timer = setTimeout(stop, 2500);
  }
  function navigate(url) {
    if (DEMO) { window.open(url, '_blank', 'noopener'); return; }
    window.location.href = url;
  }
  function openCart() {
    // A theme or cart app can take over by calling event.preventDefault()
    var ev = new CustomEvent('kfs:open-cart', { cancelable: true });
    if (!document.dispatchEvent(ev)) return;
    // The reader sits above the Kaching cart (z-index ~1050), so close it first, without the slide-out.
    close(false, true);
    // Kaching opens its side cart when the header cart link is clicked (that link is the theme's
    // own way in, see custom.main_scripts.js: .element-cart). The desktop icon is hidden below the
    // medium breakpoint, where the mobile icon is the visible one. Without either, go to the cart page.
    var icons = [$('#cart-icon-bubble'), $('#cart-icon-bubble-mobile')];
    var icon = null;
    icons.forEach(function (el) { if (!icon && el && el.getClientRects().length > 0) icon = el; });
    if (icon) { setTimeout(function () { icon.click(); }, 0); return; }
    navigate(cfg.cartUrl || (ROOT_URL + 'cart'));
  }
  function buy(source) {
    var s = stories[current], p = s.product, mode = buyMode(p);
    if (!p || mode === 'soldout') return;
    if (mode === 'choose' || (source === 'content' && cfg.contentCta === 'product')) {
      emit('kfs_view_product', params(current, { kfs_source: source }));
      navigate(p.url);
      return;
    }
    if (cartState[s.id] === 'added') { emit('kfs_view_cart', params(current)); openCart(); return; }
    if (buyBtn.getAttribute('aria-busy') === 'true') return;
    var id = s.id, idx = current;
    setBuy('loading');
    setStatus('');
    addToCart(p).then(function () {
      cartState[id] = 'added';
      if (stories[current].id === id) { setBuy('added'); setStatus('ok', 'Pridėta į krepšelį'); }
      emit('kfs_add_to_cart', params(idx, { kfs_source: source, kfs_product: p.title }));
      refreshCart();
      stepAsideForCart();
    }).catch(function () {
      if (stories[current].id === id) { setBuy('idle'); setStatus('err', 'Nepavyko pridėti. Bandykite dar kartą.'); }
      emit('kfs_add_to_cart_error', params(idx));
    });
  }
  buyBtn.addEventListener('click', function () { buy('footer'); });
  [pdpBtn, pdpLink].forEach(function (el) {
    el.addEventListener('click', function () { emit('kfs_view_product', params(current, { kfs_source: 'footer' })); });
  });

  /* ------------------------------------------------------------ navigation */
  function render(i) {
    current = i;
    var s = stories[i];
    thumbImg.src = s.image || '';
    thumb.setAttribute('data-fit', s.fit || 'contain');
    titleEl.textContent = s.title;
    countEl.textContent = (i + 1) + ' iš ' + stories.length;
    prevBtn.disabled = i === 0;
    nextBtn.disabled = i === stories.length - 1;
    segs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    pageLink.href = s.pageUrl || (s.product && s.product.url) || '#';
    if (DEMO) pageLink.target = '_blank';
    renderFoot(i);
    load(i);
    markSeen(s.id);
  }
  function go(i, source) {
    if (!isOpen || i < 0 || i >= stories.length || i === current) return;
    var from = current;
    render(i);
    announce.textContent = (i + 1) + ' iš ' + stories.length + ': ' + stories[i].title;
    if (historyMode) { try { history.replaceState({ kfs: stories[i].id, searchParams: location.search.slice(1) }, '', '#' + HASH + stories[i].id); } catch (e) {} }
    emit('kfs_navigate', params(i, { kfs_from: from + 1, kfs_source: source }));
  }

  // Zoho SalesIQ can set its display inline with !important, which beats the stylesheet rule in
  // html.kfs-lock; so the chat is also hidden inline, and its previous inline values restored on close.
  var CHAT_SEL = '#zsiq_float, .zsiq_floatmain, .zsiq_theme1, [data-id="zsalesiq"], #zsiq_chat_wrap';
  var chatHidden = [];
  function hideChat() {
    if (chatHidden.length) return;
    $$(CHAT_SEL).forEach(function (el) {
      var st = el.style;
      chatHidden.push({
        el: el,
        display: st.getPropertyValue('display'), displayPrio: st.getPropertyPriority('display'),
        visibility: st.getPropertyValue('visibility'), visibilityPrio: st.getPropertyPriority('visibility')
      });
      st.setProperty('display', 'none', 'important');
      st.setProperty('visibility', 'hidden', 'important');
    });
  }
  function showChat() {
    chatHidden.forEach(function (h) {
      h.el.style.removeProperty('display');
      h.el.style.removeProperty('visibility');
      if (h.display) h.el.style.setProperty('display', h.display, h.displayPrio);
      if (h.visibility) h.el.style.setProperty('visibility', h.visibility, h.visibilityPrio);
    });
    chatHidden = [];
  }

  function lockScroll() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--kfs-sbw', Math.max(0, sbw) + 'px');
    document.documentElement.classList.add('kfs-lock');
    hideChat();
  }
  function unlockScroll() {
    showChat();
    document.documentElement.classList.remove('kfs-lock');
    document.documentElement.style.removeProperty('--kfs-sbw');
  }

  function open(i, source, trigger) {
    if (isOpen) { go(i, source); return; }
    clearTimeout(closeTimer);
    opener = trigger || document.activeElement;
    isOpen = true;
    openedAt = Date.now();
    panel.style.transform = '';
    overlay.style.opacity = '';
    lockScroll();
    layer.hidden = false;
    current = -1;
    render(i);
    void layer.offsetWidth; // commit the start position so the panel slides in
    layer.classList.add('is-visible');
    focusEl(panel);
    document.addEventListener('keydown', onKey, true);
    if (source === 'link') historyMode = 'landed';
    else if (source === 'history') historyMode = 'pushed';
    else {
      try { history.pushState({ kfs: stories[i].id, searchParams: location.search.slice(1) }, '', '#' + HASH + stories[i].id); historyMode = 'pushed'; }
      catch (e) { historyMode = null; }
    }
    emit('kfs_open', params(i, { kfs_source: source }));
  }

  function close(viaHistory, instant) {
    if (!isOpen) return;
    isOpen = false;
    document.removeEventListener('keydown', onKey, true);
    layer.classList.remove('is-visible');
    emit('kfs_close', params(current, { kfs_seconds: Math.round((Date.now() - openedAt) / 1000) }));
    var mode = historyMode;
    historyMode = null;
    if (!viaHistory) {
      if (mode === 'pushed') { try { history.back(); } catch (e) {} }
      else if (mode === 'landed') { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
    }
    function finish() {
      layer.hidden = true;
      panel.style.transform = '';
      overlay.style.opacity = '';
      unlockScroll();
      if (!instant && opener && document.contains(opener)) focusEl(opener);
    }
    if (instant) { clearTimeout(closeTimer); finish(); return; }
    closeTimer = setTimeout(finish, reduceMotion ? 0 : 340);
  }

  function focusables() {
    return $$('button:not([disabled]), a[href], iframe, [tabindex]:not([tabindex="-1"])', panel).filter(function (el) {
      return !el.closest('[hidden]') && el.getClientRects().length > 0;
    });
  }
  function onKey(e) {
    if (!isOpen) return;
    var a = document.activeElement;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && panel.contains(a) && a !== frame) {
      e.preventDefault();
      go(current + (e.key === 'ArrowRight' ? 1 : -1), 'keyboard');
      return;
    }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  }

  $$('[data-kfs-close]', layer).forEach(function (el) { el.addEventListener('click', function () { close(); }); });
  // a click that lands on the layer itself (not the panel) is a click outside the panel
  layer.addEventListener('click', function (e) { if (e.target === layer) close(); });
  prevBtn.addEventListener('click', function () { go(current - 1, 'button'); });
  nextBtn.addEventListener('click', function () { go(current + 1, 'button'); });
  $('[data-kfs-retry]', layer).addEventListener('click', function () {
    var s = stories[current];
    if (s && s.url) delete docCache[s.url];
    load(current, true);
  });

  window.addEventListener('popstate', function () {
    var id = idFromHash();
    if (!id) { if (isOpen) close(true); return; }
    var i = indexOfId(id);
    if (i === -1) return;
    if (isOpen) go(i, 'history');
    else open(i, 'history', $('.kfs-item[data-index="' + i + '"] .kfs-link', root));
  });

  /* ------------------------------------------------------------ swipe down to close (mobile sheet) */
  var drag = null;
  head.addEventListener('pointerdown', function (e) {
    if (!mqMobile.matches || !isOpen) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest('button, a')) return;
    drag = { y0: e.clientY, t0: Date.now(), dy: 0, id: e.pointerId };
    try { head.setPointerCapture(e.pointerId); } catch (err) {}
    layer.classList.add('is-dragging');
  });
  head.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    drag.dy = Math.max(0, e.clientY - drag.y0);
    panel.style.transform = 'translate3d(0,' + drag.dy + 'px,0)';
    overlay.style.opacity = String(Math.max(0, 1 - drag.dy / (panel.offsetHeight || 600)));
  });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    layer.classList.remove('is-dragging');
    var velocity = d.dy / Math.max(1, Date.now() - d.t0);
    if (d.dy > 120 || (d.dy > 24 && velocity > 0.6)) {
      panel.style.transform = 'translate3d(0,100%,0)';
      overlay.style.opacity = '0';
      close();
    } else {
      panel.style.transform = '';
      overlay.style.opacity = '';
    }
  }
  head.addEventListener('pointerup', endDrag);
  head.addEventListener('pointercancel', endDrag);

  /* ------------------------------------------------------------ row → reader */
  items.forEach(function (li) {
    var i = parseInt(li.getAttribute('data-index'), 10);
    var a = $('.kfs-link', li);
    if (!a || isNaN(i) || !stories[i]) return;
    var warm = function () { getDoc(stories[i]).catch(function () {}); };
    a.addEventListener('pointerenter', warm, { once: true });
    a.addEventListener('focus', warm, { once: true });
    a.addEventListener('touchstart', warm, { once: true, passive: true });
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open(i, 'row', a);
    });
  });

  // deep link: /collections/naujienos#apzvalga-<id> opens that story
  var startId = idFromHash();
  if (startId) {
    var startIndex = indexOfId(startId);
    if (startIndex !== -1) {
      setTimeout(function () { open(startIndex, 'link', $('.kfs-item[data-index="' + startIndex + '"] .kfs-link', root)); }, 0);
    }
  }
})();
